import { render, staticRenderFns } from "./UserUpload.vue?vue&type=template&id=2d9cb474&scoped=true"
import script from "./UserUpload.vue?vue&type=script&lang=js"
export * from "./UserUpload.vue?vue&type=script&lang=js"
import style0 from "./UserUpload.vue?vue&type=style&index=0&id=2d9cb474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9cb474",
  null
  
)

export default component.exports